import { isReferenceJob } from './reference-job';

const WORKSPACE_ROUTE = /^\/tasks\/\d+\/(references\/\d+\/)?jobs\/\d+\/?$/;

export function isWorkspaceRoute(pathname: string): boolean {
    return WORKSPACE_ROUTE.test(pathname);
}

export function workspacePath(taskId: number, jobId: number, referenceId?: number | null): string {
    return typeof referenceId === 'number' ?
        `/tasks/${taskId}/references/${referenceId}/jobs/${jobId}` : `/tasks/${taskId}/jobs/${jobId}`;
}

// task jobs and reference jobs are numbered independently: id equality alone may show the wrong one
export function routeJob<T>(
    instance: T | null | undefined, requestedId: number | null, jobId: number, kind: 'task' | 'reference',
): T | null | undefined {
    const sameId = jobId === requestedId || (Number.isNaN(jobId) && Number.isNaN(requestedId as number));
    if (!sameId) return null;
    if (instance && isReferenceJob(instance) !== (kind === 'reference')) return null;
    // the previous job stays in the store while the next one loads
    if (instance && (instance as any).id !== jobId) return null;
    return instance;
}

// the job to keep on screen while the routed one loads: the page stays instead of a blank spinner
export function staleJob<T>(instance: T | null | undefined, routed: T | null | undefined): T | null {
    return routed === null && instance ? instance : null;
}

// `undefined` is "not found" and must not fall back to the previous job
export function shownJob<T>(routed: T | null | undefined, stale: T | null): T | null | undefined {
    return routed === null ? stale : routed;
}
